import React, { Component } from "react";
import poor from "../assets/poor.svg";
import middle from "../assets/middle.svg";
import good from "../assets/good.svg";
import excellent from "../assets/excellent.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class PollAnswers extends Component {
  // constructor(props) {
  //     super(props);
  //     console.log(this.props);
  // }
  render() {
    console.log(this.props.value);
    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        {this.props.value.toString().indexOf("1") > -1 && (
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 300, hide: 200 }}
            overlay={
              <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
                ضعیف
              </Tooltip>
            }
          >
            <div style={{ userSelect: "none" }}>
              <img
                src={poor}
                alt=""
                style={{ objectFit: "contain", height: "25px" }}
              />
            </div>
          </OverlayTrigger>
        )}
        {this.props.value.toString().indexOf("2") > -1 && (
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 300, hide: 200 }}
            overlay={
              <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
                متوسط
              </Tooltip>
            }
          >
            <div style={{ userSelect: "none", marginRight: "10px" }}>
              <img
                src={middle}
                alt=""
                style={{ objectFit: "contain", height: "25px" }}
              />
            </div>
          </OverlayTrigger>
        )}

        {this.props.value.toString().indexOf("3") > -1 && (
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 300, hide: 200 }}
            overlay={
              <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
                خوب
              </Tooltip>
            }
          >
            <div style={{ userSelect: "none", marginRight: "10px" }}>
              <img
                src={good}
                alt=""
                style={{ objectFit: "contain", height: "25px" }}
              />
            </div>
          </OverlayTrigger>
        )}

        {this.props.value.toString().indexOf("4") > -1 && (
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 300, hide: 200 }}
            overlay={
              <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
                عالی
              </Tooltip>
            }
          >
            <div style={{ userSelect: "none", marginRight: "10px" }}>
              <img
                src={excellent}
                alt=""
                style={{ objectFit: "contain", height: "25px" }}
              />
            </div>
          </OverlayTrigger>
        )}
      </div>
    );
  }
}
